<template>
  <div :id="modalId" ref="dropdown" class="large date-filter-modal"
       uk-dropdown="pos: bottom-right; mode: click; animation: uk-animation-scale-up">

    <h4 class="mb-3">
      <i class="uil-filter"/> {{ title || $t('general.filter_list') }}
    </h4>

    <div class="date-filter-modal__body">
      <AppDatePicker v-model="localDate"
                     :label="dateLabel || $t('general.date')"
                     :show-presets="true"
                     :show-time="false"
                     mode="range"
                     panel-position="bottom"
      />
    </div>

    <div class="uk-flex uk-flex-right mt-3">
      <button class="btn btn-light mr-2" type="button" @click="clear">
        {{ $t('general.clear_all') }}
      </button>
      <a :href="'#' + modalId" class="btn btn-primary grey" @click="apply">
        <i class="uil-filter"></i>
        {{ $t('general.filter') }}
      </a>
    </div>
  </div>
</template>

<script>
import AppDatePicker from "@/view/components/ui/AppDatePicker.vue";

export default {
  name: "DateFilterModal",
  components: {
    AppDatePicker,
  },
  props: {
    modalId: {
      type: String,
      default: "date-filter-modal",
    },
    value: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    dateLabel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localDate: this.cloneDate(this.value),
    };
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.localDate = this.cloneDate(val);
      },
    },
  },
  methods: {
    cloneDate(val) {
      if (!val) return null;
      return {
        start: val.start || null,
        end: val.end || null,
      };
    },
    toDateParam(value) {
      if (!value) return null;
      return new Date(value).toISOString().split("T")[0];
    },
    apply() {
      const fromDate = this.toDateParam(this.localDate?.start);
      const toDate = this.toDateParam(this.localDate?.end || this.localDate?.start);

      this.$emit("input", this.cloneDate(this.localDate));
      this.$emit("filter", {
        selectedDate: this.cloneDate(this.localDate),
        from_date: fromDate,
        to_date: toDate,
      });
      this.hide();
    },
    clear() {
      this.localDate = null;
      this.$emit("input", null);
      this.$emit("clear");
      this.hide();
    },
    hide() {
      const dropdown = this.$refs.dropdown;
      if (dropdown) {
        UIkit.dropdown(dropdown).hide();
      }
    },
  },
};
</script>

<style scoped>
.date-filter-modal {
  min-width: 320px;
  overflow: visible !important;
}

.date-filter-modal__body {
  overflow: visible !important;
}
</style>

<style>
.date-filter-modal[uk-dropdown] {
  overflow: visible !important;
}
</style>
